import React from 'react';
import { map, isEmpty } from 'lodash';
import { Form, Col, Button, Table, Row } from 'react-bootstrap';
import uuid from 'uuid/v1';
import useTimeStore from '../ZustandProvider';

let domainWithoutLastSlash = '';
const LayerEditorMaps = () => {
  const layers = useTimeStore(state => state.layers);
  const setLayers = useTimeStore(state => state.setLayers);

  // const [isFromTable, setIsFromTable] = React.useState(true);
  const [limit, setLimit] = React.useState(1000);
  const [limitB, setLimitB] = React.useState(1000);
  // const [loading, setLoading] = React.useState(false);
  const [simpleProp, setSiempleProp] = React.useState({});
  const [stateForm, setStateForm] = React.useState([]);
  const [stateCheck, setStateCheck] = React.useState([]);
  const [cadenaFiltrada, setCadenaFiltrada] = React.useState([]);
  const [fetaureid, setFeatureId] = React.useState('');
  const [element, setElement] = React.useState([]);
  const [previewMapUrl, setPreviewMapUrl] = React.useState('');
  const [indexLayer, setIndexLayer] = React.useState(1000);

  const LoadPropertie = async (id, domain, index) => {
    // setLoading(true);
    const response = await fetch(`${domain}/collections/${id}/items.json?limit=${limit}`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const data = await response.json();
    const properties = layers[parseInt(index, 10)].geojsonProps;
    const propertiesJson = map(data.features, item => {
      return item.properties;
    });
    const unique = map(properties, value => {
      return {
        value: [...new Set(map(propertiesJson, item => item[value.name]))],
        type: value.dataType,
        name: value.name
      };
    });
    const fill = Array(unique.length).fill('');
    setStateForm(fill);

    setSiempleProp(unique);
    // setLoading(false);
  };
  const changeAll = event => {
    const check = event.target.checked;
    let newState = [];
    if (check) {
      newState = new Array(stateCheck.length).fill(true);
      setStateCheck(newState);
      setElement('');
    } else {
      newState = new Array(stateCheck.length).fill(false);
      setStateCheck(newState);
      setElement('');
    }
  };
  const handleLayer = event => {
    const values = event.split('&&&', 2);
    const url = values[0];
    const index = values[1];
    setIndexLayer(index);
    const spl1 = url.split('/collections/', 2);
    const id = spl1[1].split('/items', 1)[0];
    const domain = spl1[0];
    setFeatureId(id);
    domainWithoutLastSlash = domain;
    LoadPropertie(id, domain, index);
  };
  const changeFilterType = event => {
    const newState = simpleProp.map((value, index) => {
      if (event.target.id === value.name) {
        return !stateCheck[index];
      }
      return stateCheck[index];
    });
    const properties = simpleProp.map((value, index) => {
      if (newState[index]) {
        return value.name;
      }
      return null;
    });
    const newArr = properties.filter(a => a);
    setElement(`&properties=${newArr.join()}`);
    setStateCheck(newState);
  };
  const changeFilter = (event, name, index) => {
    const fill = Array(simpleProp.length).fill('-');
    const value = event.target.value.trim();
    const string = `&${name}=${value}`;

    if (!isEmpty(value)) {
      setCadenaFiltrada(string);
    } else {
      setCadenaFiltrada('');
    }

    fill[index] = value;

    setStateForm(fill);
  };

  const updateUrls = () => {
    const str = `?limit=${limit}${element}${cadenaFiltrada}`;
    const UrlHtml = `items.json${str}`;
    if (!isEmpty(fetaureid)) {
      setPreviewMapUrl(`${domainWithoutLastSlash}/collections/${fetaureid}/${UrlHtml}`);
    }
  };
  const updateLayers = () => {
    if (indexLayer <= layers.length) {
      const A = { ...layers[indexLayer], url: previewMapUrl, _id: uuid() };
      const B = layers;
      B[indexLayer] = A;
      setLayers([...B]);
    }
  };

  React.useEffect(() => {
    updateUrls();
  }, [limit, element, cadenaFiltrada]);
  React.useEffect(() => {
    updateLayers();
  }, [previewMapUrl]);

  return (
    <>
      <Row>
        <Col xs={12} className="flex-row align-items-center">
          <Form.Control
            as="select"
            defaultValue=""
            className="mr-sm-2"
            id="Schema"
            onChange={event => handleLayer(event.target.value)}
            custom
          >
            <option value="">-</option>
            {map(layers, (value, index) => {
              if (value.isFeature === true) {
                return (
                  <option value={`${value.url}&&&${index}`} key={value.publicDataId}>
                    {value.name}
                  </option>
                );
              }
              return false;
            })}
          </Form.Control>
          <div className="row">
            <div className="col-12">
              <Table striped size="sm">
                <tbody>
                  <tr>
                    <td className="bg-secondary text-white ">
                      <Form.Check
                        size="sm"
                        // disabled={!isFromTable}
                        id="All"
                        key={uuid()}
                        onChange={e => changeAll(e)}
                        custom
                        defaultChecked={stateCheck.every(v => v === true)}
                      />
                    </td>
                    <td className="bg-secondary text-white ">
                      <h6>Name</h6>
                    </td>
                    <td className="bg-secondary text-white">
                      <h6> Type </h6>
                    </td>
                    <td className="bg-secondary text-white">
                      <h6> Values </h6>
                    </td>
                  </tr>

                  {map(simpleProp, (item, index) => (
                    <tr key={uuid()}>
                      <td>
                        <Form.Check
                          size="sm"
                          id={item.name}
                          // disabled={!isFromTable}
                          key={uuid()}
                          onChange={event => changeFilterType(event)}
                          custom
                          defaultChecked={stateCheck[index]}
                        />
                      </td>
                      <td>{item.name}</td>
                      <td>{item.type}</td>
                      <td>
                        {!isEmpty(item.value) && (
                          <Form.Control
                            as="select"
                            // disabled={!isFromTable}
                            key={uuid()}
                            size="sm"
                            name="Props"
                            value={stateForm[index]}
                            onChange={event => changeFilter(event, item.name, index)}
                          >
                            <option key={uuid()} value="">
                              Choose
                            </option>
                            {map(item.value, prop => {
                              return (
                                <option value={prop} key={uuid()}>
                                  {prop}
                                </option>
                              );
                            })}
                          </Form.Control>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>

      <div className="row flex-row align-items-center">
        <div className="col-6">
          <div className="row">
            <div className="col-6">
              <Form.Control
                type="number"
                // disabled={!isFromTable}
                min={0}
                max={10000}
                defaultValue={limitB}
                onChange={e => setLimitB(e.target.value)}
                step={1}
                precision={2}
                name="Limit"
                size="sm"
              />
            </div>
            <div className="col-6">
              <Button
                variant="success"
                block
                onClick={() => {
                  setLimit(limitB);
                }}
                size="sm"
              >
                Set Limit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LayerEditorMaps;
